import {
	PATIENT_ACCOUNT_ORDERS_ACTION_TYPES,
	PatientAccountOrdersActions,
	PatientAccountOrdersState,
} from '../../../../types/patientAccountOrders'

const initialState: PatientAccountOrdersState = {
	records: [],
}

export default (
	state = initialState,
	action: PatientAccountOrdersActions
): PatientAccountOrdersState => {
	switch (action.type) {
		case PATIENT_ACCOUNT_ORDERS_ACTION_TYPES.PATIENT_ACCOUNT_ORDERS: {
			return {
				records: action.payload,
			}
		}
		default: {
			return state
		}
	}
}
